import React from 'react'

// Style sheet
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/seaTemperature.scss';

// Bootstrap Components
import Container from 'react-bootstrap/Container';

export default function SeaTemperature() {
  return (
    <Container>
      <div id="seaTemperatureBox">
        <div id="seaTemperatureBox_Title">全球海洋表面溫度 (seatemperature.org)</div>
        <div id="seaTemperatureBox_Content">
          <img 
            src="https://www.seatemperature.org/public/sea-temperature.webp" 
            alt="Description" 
            style={{ width: "100%", height: "auto" }} 
          />
        </div>
      </div>
    </Container>
    
  )
}
